import React from 'react';

const LogoutUser = () => (
  <svg viewBox="0 0 21 21" className="logout-svg">
    <path
      d="M10.2825,8.7825 C11.7897361,7.59665523 12.3797951,5.58586152 11.7523404,3.77360073 C11.1248858,
             1.96133994 9.41780825,0.745878201 7.5,0.745878201 C5.58219175,0.745878201 3.87511422,1.96133994 3.24765958,
             3.77360073 C2.62020494,5.58586152 3.2102639,7.59665523 4.7175,8.7825 C2.15032266,9.8110096 0.357462661,
             12.1688223 0.0525,14.9175 C0.00693650814,15.3317136 0.305786438,15.7044365 0.72,15.75 C1.13421356,
             15.7955635 1.50693651,15.4967136 1.5525,15.0825 C1.89347335,12.047056 4.46046518,9.75227142 7.515,
             9.75227142 C10.5695348,9.75227142 13.1365266,12.047056 13.4775,15.0825 C13.5197363,15.4642012 13.8434762,
             15.7523297 14.2275,15.75 L14.31,15.75 C14.7192308,15.7029135 15.0138931,15.3345856 14.97,14.925 C14.6635631,
             12.168232 12.8606358,9.80567603 10.2825,8.7825 L10.2825,8.7825 Z M7.5,8.25 C5.84314575,8.25 4.5,
             6.90685425 4.5,5.25 C4.5,3.59314575 5.84314575,2.25 7.5,2.25 C9.15685425,2.25 10.5,3.59314575 10.5,
             5.25 C10.5,6.04564947 10.1839295,6.80871121 9.62132034,7.37132034 C9.05871121,7.93392948 8.29564947,8.25 7.5,8.25 Z"
    />
  </svg>
);

export default LogoutUser;
